import React from 'react'
import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title: string
  description: string
  path: string
  image?: string
  type?: string
  jsonLd?: object | object[]
}

const SITE_URL = 'https://miamigo.ai'
const DEFAULT_IMAGE = `${SITE_URL}/android-chrome-512x512.png`

const SEO: React.FC<SEOProps> = ({ title, description, path, image, type = 'website', jsonLd }) => {
  const url = `${SITE_URL}${path}`
  const jsonLdItems = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image || DEFAULT_IMAGE} />
      <meta property="og:site_name" content="MiAmigo.AI" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_IMAGE} />

      {jsonLdItems.map((item, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  )
}

export default SEO
export { SITE_URL }
